export const products = [
  {
    id: 1,
    img: "https://i.ibb.co/Br6L8JV/Living-Histories-1.jpg",
    link: "https://www.imaginarycountry.org/www_09/726/Index.html",
  },
  {
    id: 2,
    img: "https://i.ibb.co/QYChtjh/Long-Thumbnail-Images.png",
    link: "https://worldlyweather.netlify.app/",
  },
  {
    id: 3,
    img: "",
    link: "http://lama.dev",
  },
  {
    id: 4,
    img: "",
    link: "http://lama.dev",
  },
  {
    id: 5,
    img: "",
    link: "http://lama.dev",
  },
  {
    id: 6,
    img: "",
    link: "http://lama.dev",
  },
];
